import { defineStore } from 'pinia';

export default defineStore('global', {
//  persist: true,
  state: () => ({
    bannerHeight: 55,
    showBanner: true,
    modal: {
      name: '',
      id: '',
      showFooter: false,
      title: '',
      descriptionPlaceholder: '',
      customField: '',
      propertyName: '',
      operatorName: '',
      operatorId: '',
      enquiryTypeFull: '',
      subscription: '',
      enquiryRegion: '',
      enquiryDistrict: '',
      homeTypes: '',
      typesOfHomes: '',
      eventType: '',
      refreshAfterClose: false
    },
    isMobile: false,
  }),
  actions: {
    setShowBanner(showBanner) {
      this.showBanner = showBanner;
    },
    setBannerHeight(bannerHeight) {
      this.bannerHeight = bannerHeight;
    },
    setIsMobile(isMobile) {
      this.isMobile = isMobile;
    },
    setModal(modal) {
      this.modal = modal;
    },
  },
})
